import api from "../../../services/api.service"


export const guidelineModule = {
    namespaced: true,
    state: {
        data: {types:[],categories:[]},
    },
    getters: {
        canReadRealEstate(state, getters, rootState, rootGetters) {
            return rootGetters['user/canRead']('real_estate');
        },
        canEditRealEstate(state, getters, rootState, rootGetters) {
            return rootGetters['user/canEdit']('real_estate');
        },
        getAllCategories(state) {
            if (state.data == null || state.data.categories == null)
                return [];
            return state.data.categories;
        },

        getAllTypes(state) {
            if (state.data == null || state.data.types == null)
                return [];
            return state.data.types;
        },

        allGuidelineStatus() {
            return [
                { value: "online", text: ('ONLINE') },
                { value: "offline", text: ('OFFLINE') },
                { value: "inProgress", text: ('IN PROGRESS') },
                { value: "error", text: ('ERROR') }
            ];
        },



    },
    mutations: {
        updateData(state, data) {
            let stateData = {};
            stateData.loaded = true;
            stateData.categories = data["Categories"];
            stateData.types = data["Types"];
            state.data = stateData;
        }
    },
    actions: {

        copySuccess(actions,id){
            actions.dispatch('notifications/success',
                {title: 'Success', message: 'Guideline  ID '+id+' copied'},
                {root: true});

        },


        getAllGuidelines(actions,{ page, amount, filter,sortcolumn, sortby }) {

            return new Promise(function (resolve, reject) {

                    api.sendRequest('guideline/get', {
                        buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),
                        page,
                        amount,
                        sortcolumn,
                        sortby
                    },filter).then(
                        (ans) => {
                            if (ans["Guidelines"] == null)
                                return reject('Could not get Guidelines ');

                            resolve(ans);
                        }, (error) => {
                            reject(error.message)
                        })
                })

        },

        deleteService(actions,{id}){
            return new Promise((resolve, reject) => {

                api.sendRequest('guideline/delete/'+id, {}).then(
                    (ans) => {

                        if (ans["Deleted"] == null)
                            return reject('Could not delete service item ');

                        resolve(ans["Deleted"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        getGuidelineById(actions,id){
            return new Promise((resolve, reject) => {

                api.sendRequest('guideline/id/'+id, {}).then(
                    (ans) => {

                        if (ans["Guideline"] == null)
                            return reject('Could not get guideline ');

                        resolve(ans["Guideline"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        updateDocumentFile(action, {id, file}) {
            return new Promise(function (resolve, reject) {
                api.sendRequest('guideline/update/file/' + id, null, file).then(
                    (ans) => {

                        action.dispatch('notifications/success',
                            {
                                title: {text: 'file %s', arguments: ['status']},
                                message: {text: '%s updated successfully', arguments: ['file']}
                            },
                            {root: true});
                        resolve(ans["editableFields"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },

        updateGuideline(actions,{guideline}){
            return new Promise((resolve, reject) => {

                api.sendRequest('guideline/update',null, guideline).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Update guideline', message: 'Guideline updated successfully'},
                            {root: true});

                        if (ans["RowsUpdated"] == null)
                            return reject('Could not update guideline ');

                        resolve(ans["RowsUpdated"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        sendEmail(actions,guideline){
            return new Promise((resolve, reject) => {

                api.sendRequest('guideline/sendEmail',null, guideline).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Email Support', message: 'Email was sent successfully'},
                            {root: true});

                        if (ans["GuidelineId"] == null)
                            return reject('Could not sent email');

                        resolve(ans["GuidelineId"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        addGuideline(actions,{guideline}){
            return new Promise((resolve, reject) => {
                api.sendRequest('guideline/create', null,guideline).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Add guideline', message: 'Guideline created successfully'},
                            {root: true});

                        if (ans["Guideline"] == null)
                            return reject('Could not create guideline ');

                        console.log("guideline answer created: ",ans)
                        resolve(ans["Guideline"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        }
    },
};
